<template>
  <div class="animated fadeIn col-md-12">
    <SearchCard
      :filterCatch="true"
      :title="$lang.searchParvandeh"
      :url="$config.api_url + $config.survey.my_survey"
      :html="false"
      :allowFields="$lang.search_parvandeh_fildes"
      ref="searchParvandeh"
      :hasAdd="true"
      @handleAdd="showAddModal"
    >
      <template slot="html" slot-scope="{ item }">
        <b-col
          cols="12"
          class="py-1 mb-3 border-bottom d-flex align-items-center justify-content-between"
        >
          <div class="d-flex align-items-center">
            <span
              class="mr-2 fs_1_3rem w_h_40 border bg-light rounded-circle p-1 d-flex align-items-center justify-content-center"
              v-b-tooltip.hover
              :title="`زمان ایجاد :${pathOr(
                '',
                ['created_at', 'jalali'],
                item
              )} ایجاد کننده : ${pathOr('', ['person', 'name'], item)} ${pathOr(
                '',
                ['person', 'family'],
                item
              )}`"
            >
              <i class="fas fa-comments text-primary" />
            </span>
            <b
              class="px-1 fs_1rem"
              v-text="
                `${pathOr('', ['survey_group', 'name'], item)} - ${pathOr(
                  '',
                  ['person', 'parvandeh', 'parvandeh_number'],
                  item
                )}`
              "
            />
          </div>
          <b-button variant="outline-success" size="sm">
            <i class="fas fa-edit fa-lg mr-1" />
            <b v-text="$lang.edit" />
          </b-button>
        </b-col>
        <b-col cols="12" md="2" class="text-center">
          <ImageBox
            :downloadCode="pathOr(null, ['download_code'], item)"
            imageClass="w-100 h-auto"
            :defaultImage="defaultImage"
            loadingClass="left-0 top-0 w-100"
            :hasPreview="false"
          />
          <b-img-lazy
            fluid
            thumbnail
            :onerror="$config.images.onerrorDefaultImg"
            :src="''"
            class="bg-white"
            width="150"
          />
        </b-col>
        <b-col cols="12" md="10">
          <b-row> </b-row>
        </b-col>
        <b-col
          cols="12"
          md="12"
          class="float-left text-md-right text-center p-1 border-top mt-3"
        >
        </b-col>
      </template>
    </SearchCard>
    <b-modal
      no-close-on-backdrop
      variant="primary"
      header-bg-variant="primary"
      content-class="border-primary"
      v-model="addModal"
      size="lg"
      ok-only
      hide-footer
      hide-header
    >
      <AddSurvey
        @closeModal="addModal = false"
        @updateRefreshGetData="updateRefreshGetData"
      />
    </b-modal>
  </div>
</template>

<script>
import SearchCard from "@/components/base/searchCard";
import { ImageBox } from "@/components/re-design";
import { generateStoreGetters } from "@/shared/utils";
import { pathOr, includes } from "ramda";

export default {
  components: {
    SearchCard,
    ImageBox,
  },
  data() {
    return {
      addModal: false,
    };
  },
  computed: {
    roles() {
      return generateStoreGetters(["userInfo", "roles"]) || [];
    },
  },
  watch: {
    refreshGetData(value) {
      value && this.getData();
    },
  },
  methods: {
    pathOr,
    includes,
    async getData() {
      await this.$refs.searchParvandeh.getItems();
      this.$emit("updateRefreshGetData", false);
    },
    showAddModal() {
      this.addModal = true;
    },
  },
};
</script>

<style scoped lang="scss">
.grid-img-crd {
  /* width: 150px;
  height: auto;
  margin: auto;
  display: block; */
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  img {
    width: 95px;
    height: auto;
  }
}
.fs_1_3rem {
  font-size: 20px;
}
.w_h_40 {
  width: 40px;
  height: 40px;
}
</style>
